/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  class RushPersonalization extends HTMLElement {
    constructor() {
      super();

      this.parentId = this.getAttribute('data-parent-id');
      this.parentSection = document.getElementById('shopify-section-'.concat(this.parentId));
      this.form = this.parentSection.querySelector('product-form');
      this.product = window.theme.rushProduct;
      this.checkbox = this.querySelector('input[type=checkbox]');
      
      document.addEventListener('theme:cart:add', (e) => {
        if(e.detail.button.form.querySelector('[name="section-id"]').value == this.parentId && this.checkbox.checked) {
          setTimeout(() => {
            this.addRushProductToCart();
          }, 500);
        }
      });

      this.addEventListener('change', (e) => {
        this.updateProductProperty(e.target.checked);
      });

      document.addEventListener('theme:cart:change', (e) => {
        setTimeout(() => {
          this.refreshRushProductInPDP();
        }, 500);
      });

      this.addRushProductToCart();
    }

    updateProductProperty (rush) {
      if( ! this.form) return;
      
      const rushPersoProperty = this.form.querySelector(`input[name="properties[Rush]"]`);
      
      if( ! rush) {
        if (rushPersoProperty) rushPersoProperty.remove();

        return;
      }

      if (rushPersoProperty) return;

      const rushProperty = document.createElement('input');

      rushProperty.setAttribute('type', 'hidden');
      rushProperty.setAttribute('name', `properties[Rush]`);
      rushProperty.setAttribute('value', 'Yes');

      this.form.querySelector('form').appendChild(rushProperty);
    }

    async refreshRushProductInPDP () {
      // Get the items in the cart first and see if rush product is already in the cart
      const items = await fetch('/cart.js').then(response => response.json()).then(data => data.items);

      this.checkbox.checked = false;

      this.updateProductProperty(false);

      if(items.length == 0) {
        return;
      }

      for (let item of items) {
        if (item.product_id == this.product.id) {
          this.checkbox.checked = true;
          this.updateProductProperty(true);

          return;
        }
      }
    }

    async addRushProductToCart () {
      // Get the items in the cart first and see if rush product is already in the cart
      const items = await fetch('/cart.js').then(response => response.json()).then(data => data.items);

      let hasRushPersonalization = false,
          rushProductInCart = false;

      for (let item of items) {
        if (item.product_id == this.product.id) {
          rushProductInCart = true;
        }

        if (item.properties && item.properties['Rush'] == 'Yes') {
          hasRushPersonalization = true;
        }
      }

      if ( ! hasRushPersonalization || rushProductInCart) return;

      fetch('/cart/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: this.product.variants[0].id,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { detail: data }));
      });
    }

    async removeRushProductFromCart () {
      // Get the items in the cart first and see if rush product is still in the cart
      // and if so, look for any products that have the rush personalization property
      // If no products have the rush personalization property, remove the rush product from the cart
      // and refresh the cart
      const rushProduct = window.theme.rushProduct,
            items = await fetch('/cart.js').then(response => response.json()).then(data => data.items),
            productsWithRushProperty = [];

      let rushProductInCart = false,
          rushProductInCartWithRushProperty = false,
          rushProductLineIndex = null;

      items.forEach((item, i) => {
        if (item.product_title == rushProduct.title) {
          rushProductInCart = true;
          rushProductLineIndex = i + 1;
        }

        if (item.properties && item.properties['Rush'] == 'Yes') {
          rushProductInCartWithRushProperty = true;
          const productProperties = {};

          for (const property in item.properties) {
            if (property !== 'Rush') {
              productProperties[property] = item.properties[property];
            }
          }

          productsWithRushProperty.push({
            quantity: item.quantity,
            properties: productProperties, 
            line: i + 1
          });
        }
      });

      // If the rush product is not in the cart, remove the rush personalization property from all
      // products in cart and exit
      if ( ! rushProductInCart) {
        for (const item in productsWithRushProperty) {
          await fetch(theme.routes.cart_change_url, {
            method: 'post',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({
              line: productsWithRushProperty[item].line,
              quantity: productsWithRushProperty[item].quantity,
              properties: productsWithRushProperty[item].properties
            }),
          })
            .then(response => response.json())
            .then(cart => {
              document.dispatchEvent(new CustomEvent('theme:cart:refresh', { detail: cart }));
            });
        }

        return;
      }

      // Exit if the rush product is in the cart and one product has the rush personalization property
      if (rushProductInCart && rushProductInCartWithRushProperty) {
        return;
      }

      const data = {
        line: rushProductLineIndex,
        quantity: 0,
      };

      this.updateProductProperty(false);

      fetch(theme.routes.cart_change_url, {
        method: 'post',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(cart => {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { detail: cart }));
        });

      return;
    }
  }

  customElements.define('rush-personalization', RushPersonalization);

  document.addEventListener('theme:cart:change', async (e) => {
    setTimeout(() => {
      RushPersonalization.prototype.removeRushProductFromCart();
    }, 1500);
  });
  
  document.addEventListener('click', function (e) {
    const target = e.target;
    const rushPersoBtn = document.getElementById('product__form__custom_input--rush-personalisation');
    
    if(target.parentElement.classList.contains('product-personalizer')) {
      const rushPersonalizationElement = document.querySelector('rush-personalization');

      if(target.classList.contains('pplr_remove')) {
        rushPersoBtn.style.display = 'none';
        rushPersoBtn.parentElement.setAttribute('data-open', false);

        rushPersonalizationElement.updateProductProperty(false);
      } else {
        rushPersoBtn.style.display = 'block';
        rushPersoBtn.parentElement.setAttribute('data-open', true);

        if(rushPersonalizationElement.checkbox.checked) {
          rushPersonalizationElement.updateProductProperty(true);
        }
      }
    }
  });

  /**
   * Custom cart tracking function for Zepto Product Personaliser
   * Is called when a product with personalisation is added to the cart
   * @param {Object} data - The data object from the event
   */
  window.pplr_custom_cart_track = function(data) {
    const rushPersonalizationElement = document.querySelector('rush-personalization');
    rushPersonalizationElement.addRushProductToCart();

    const klaviyoTrack = (data) => {
      var klAjax = true;
      var _learnq = window._learnq || [];
      var cart = {
        total_price: data.total_price / 100,
        $value: data.total_price / 100,
        total_discount: data.total_discount,
        original_total_price: data.original_total_price / 100,
        items: data.items
      }

      if (item !== 'undefined') {
        cart = Object.assign(cart, item)
      }

      if (klAjax) {
        _learnq.push(['track', 'Added to Cart', cart]);
        klAjax = false;
      }
    }

    //klaviyoTrack(data);
    //window.location.reload();
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
